export function DailySalesNotes() {
  return (
    <section className="nb-card nb-ds-notes" aria-labelledby="daily-sales-notes">
      <h3 id="daily-sales-notes" className="nb-display" style={{ fontSize: 13, margin: 0 }}>
        How the numbers are counted
      </h3>
      <p>
        Each sale is counted on the day it was made (Eastern time) and stays there, even if the
        booking is later cancelled, refunded or moved to another date. This matches
        FareHarbor&apos;s Daily Sales report with &ldquo;Report on: Transaction date&rdquo;.
      </p>
      <p>
        <b>FareHarbor</b> comes from the data warehouse: every original booking except private
        events, which are left out. Moving a booking to a new date doesn&apos;t count as a new sale.
        Gross payment includes tax and fees; pre-tax is the receipt subtotal.
      </p>
      <p>
        <b>Gift cards</b> are FareHarbor gift card purchases. Nebari gift cards are not included
        yet.
      </p>
      <p>
        <b>Nebari</b> comes from the Nebari app: every order placed, whatever its status now,
        excluding comps and rebookings. Gross payment includes tax and fees; pre-tax is the order
        subtotal.
      </p>
      <p>
        Today&apos;s numbers are partial and shown lighter. The warehouse copy of FareHarbor
        bookings refreshes through the day, so today&apos;s FareHarbor numbers trail Nebari&apos;s.
      </p>
    </section>
  );
}
